import { setupLayouts } from 'virtual:generated-layouts'
// eslint-disable-next-line import/no-duplicates
import { createRouter, createWebHistory } from 'vue-router'
// eslint-disable-next-line import/no-duplicates
import { routes } from 'vue-router/auto-routes'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts(routes),
})

// 处理外部重定向的路由守卫
router.beforeEach((to) => {
  if (to.path === '/') {
    const defaultUrl = import.meta.env.VITE_APP_DEFAULT
    if (defaultUrl) {
      window.location.href = defaultUrl
      return false
    }
  }
})
